var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownRightIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.175 0.533203L5 4.34987L8.825 0.533203L10 1.7082L5 6.7082L0 1.7082L1.175 0.533203Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.175 0.533203L5 4.34987L8.825 0.533203L10 1.7082L5 6.7082L0 1.7082L1.175 0.533203Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownRightIcon);
export default __webpack_public_path__ + "static/media/dropdownRightIcon.3e49b04232202bfc8411b74b6d145861.svg";
export { ForwardRef as ReactComponent };